module.exports = __webpack_public_path__ + "img/bottom_banner.44a43246.png";